import { useEffect } from 'react';
import { createPortal } from 'react-dom';

/**
 * Renders children into document.body to escape stacking contexts
 * (e.g. fixed topbars / transformed parents). Also locks body scroll by default.
 */
export default function PortalModal({ open, children, lockScroll = true }) {
  useEffect(() => {
    if (!open || !lockScroll) return;
    const prevOverflow = document.body.style.overflow;
    const prevOverscroll = document.body.style.overscrollBehavior;

    document.body.style.overflow = 'hidden';
    document.body.style.overscrollBehavior = 'contain';

    return () => {
      document.body.style.overflow = prevOverflow;
      document.body.style.overscrollBehavior = prevOverscroll;
    };
  }, [open, lockScroll]);

  if (!open) return null;
  return createPortal(children, document.body);
}

